const allContentItemsBySubjectQuery = `query subject($concepts: String, $pageSize: Int) {
    allContentItems(concepts: $concepts, pageSize: $pageSize, type: "story", targets: [WEB,ALL]) {
        nodes {
            id
            url
            title
            sectionList
            sectionLabels
            relatedLinks {
                url
                title
                sourceId
            }
            description
            flag
            imageLarge
            source
            sourceId
            publishedAt
            updatedAt
            type
            showName
            authors {
                name
                photo {
                    aspects {
                        ratio1x1 {
                            url
                        }
                    }                          
                }
            }
            commentsEnabled
            contextualHeadlines {
                headline
                contextualLineupSlug
            }
        }
    }
}`;

export default allContentItemsBySubjectQuery;
